import { Card } from '../../components/Card';
import { TimeLabel } from '../../components/TimeLabel';
import { useOffer } from '../../hooks';
import { ControlsContainer } from '../ControlsContainer';
import { GalleryContainer } from '../GalleryContainer';
import { GeneralInfoContainer } from '../GeneralInfoContainer';
import { PublisherContainer } from '../PublisherContainer';

interface ICardContainerProps {
  onClick?: VoidFunction;
}

export function CardContainer({ onClick }: ICardContainerProps) {
  const { href, isWide, added, humanizedTimedelta } = useOffer();

  return (
    <Card
      href={href}
      isWide={isWide}
      gallery={<GalleryContainer />}
      content={<GeneralInfoContainer />}
      publisher={<PublisherContainer />}
      publicationDate={<TimeLabel added={added} humanizedTime={humanizedTimedelta} />}
      controls={<ControlsContainer />}
      onClick={onClick}
    />
  );
}
